<div class="content-view d-flex flex-column align-items-center">
  <textarea
    class="textarea w-100 mb-3 border-dark-blue form-control"
    name=""
    id=""
    placeholder="{{ 'cuentanos_tu_experiencia' | translate }}"
    rows="5"
    [formControl]="commentControl()"
  ></textarea>
  <button class="dark-blue fw-normal px-4 rounded-4" (click)="comment()">
    {{ 'valorar' | translate }}
  </button>
</div>
